// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2tM0f","steps":"styles_steps__3ZACh","imageStepOne":"styles_imageStepOne__dvdhd"};